{
  "name": "droste",
  "doc": "A strong zoom-in with the cover polygons as the only injection: the picture contains itself, smaller, again and again. Low darkenCenter so the recursion reaches the eye.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 1.045,
  "zoomexp": 1.0,
  "rot": 0.003,
  "rotr": 0.0,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0,
  "warpScale": 4,
  "warpSpeed": 0.3,
  "decay": 0.958,
  "invert": 0,
  "hueShift": 0.002,
  "darkenCenter": 0.05,
  "wave": "DOTS",
  "waveColor": 2,
  "shapes": 3,
  "energy": [
    0.3,
    0.8
  ]
}